export const sliders = (Swiper) => {
  const swiperReviews = new Swiper(`.js-swiper-reviews`, {
    slidesPerView: "auto",
    spaceBetween: 14,
    loop: true,
    navigation: {
      nextEl: ".reviews__button--next",
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
    },
  });

  if (
    window.matchMedia("(min-width: 1024px)").matches &&
    document.querySelector(`.js-swiper-catalog`) &&
    document.querySelectorAll(`.catalog-slider__item`).length === 2
  ) {
    const catalogSwiperElement = document.querySelector(`.js-swiper-catalog`);

    catalogSwiperElement.classList.remove(`js-swiper-catalog`);
    catalogSwiperElement.classList.add(`catalog-slider__inner--not-slider`);
  }

  const swiperCatalog = new Swiper(`.js-swiper-catalog`, {
    slidesPerView: "auto",
    spaceBetween: 15,
    navigation: {
      nextEl: ".catalog-slider__button--next",
      prevEl: ".catalog-slider__button--prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 26,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });

  const swiperCatalogFull = new Swiper(`.js-swiper-catalog-full`, {
    slidesPerView: 1,
    spaceBetween: 1,
    loop: true,
    navigation: {
      nextEl: ".banner__block-button",
    },
  });

  const swiperRecomend = new Swiper(`.js-swiper-recomend`, {
    slidesPerView: "auto",
    spaceBetween: 31,
    navigation: {
      nextEl: ".recommend__button--next",
      prevEl: ".recommend__button--prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });

  const hideBg = (type, swiperContainer) => {
    switch (type) {
      case `prev`:
        swiperContainer.classList.remove(`line-slider--show-bg-prev`);
        break;
      case `next`:
        swiperContainer.classList.remove(`line-slider--show-bg`);
        break;
    }
  };

  const showBg = (type, swiperContainer) => {
    switch (type) {
      case `prev`:
        swiperContainer.classList.add(`line-slider--show-bg-prev`);
        break;
      case `next`:
        swiperContainer.classList.add(`line-slider--show-bg`);
        break;
    }
  };

  const swiperLine = new Swiper(`.js-swiper-line-slider`, {
    spaceBetween: 37,
    slidesPerView: "auto",
    breakpoints: {
      768: {
        spaceBetween: 55,
      },
      1024: {
        spaceBetween: 110,
      },
    },
    on: {
      afterInit: function () {
        if (this.isBeginning && this.isEnd) {
          hideBg(`prev`, this.el);
          hideBg(`next`, this.el);
        }
      },
      reachBeginning: function () {
        hideBg(`prev`, this.el);
      },
      reachEnd: function () {
        hideBg(`next`, this.el);
      },
      transitionStart: function () {
        if (!this.isBeginning) {
          showBg(`prev`, this.el);
        }
        if (!this.isEnd) {
          showBg(`next`, this.el);
        }
      },
    },
  });

  if (window.matchMedia("(max-width: 767px)").matches) {
    const swiperImages = new Swiper(`.js-swiper-images-slider`, {
      spaceBetween: 14,
      slidesPerView: "auto",
    });

    const swiperAbout = new Swiper(`.js-swiper-about`, {
      spaceBetween: 14,
      centeredSlides: true,
      slidesPerView: "auto",
      initialSlide: 1,
    });
  }

  const swiperBrands = new Swiper(`.js-swiper-brands`, {
    spaceBetween: 14,
    slidesPerView: "auto",
    navigation: {
      nextEl: ".popular-brands__arrow-btn--next",
      prevEl: ".popular-brands__arrow-btn--prev",
      disabledClass: "popular-brands__arrow-btn--disabled",
    },

    breakpoints: {
      768: {
        spaceBetween: 20,
        slidesPerView: 4,
      },
      1280: {
        slidesPerView: 5,
      },
    },
  });

  const stocksSwiper = new Swiper(`.js-stock-swiper`, {
    spaceBetween: 20,
    slidesPerView: "auto",
    navigation: {
      nextEl: ".subcategory__button--next",
      prevEl: ".subcategory__button--prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
    },
  });

  const subcategoryMenuSwiper = new Swiper(`.js-subcategory-menu-swiper`, {
    spaceBetween: 15,
    slidesPerView: "auto",
    grabCursor: true,
    navigation: {
      nextEl: ".subcategory__button--next",
      prevEl: ".subcategory__button--prev",
    },
  });

  const categorySwiper = new Swiper(`.js-category-swiper`, {
    spaceBetween: 10,
    slidesPerView: 1,
    grabCursor: true,
    navigation: {
      prevEl: ".subcategory__button--prev",
      nextEl: ".subcategory__button--next",
      disabledClass: "subcategory__button--disabled",
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      1279: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  const stockMenuSwiper = new Swiper(`.js-stock-menu-swiper`, {
    spaceBetween: 15,
    slidesPerView: `auto`,
    grabCursor: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1279: {
        slidesPerView: 1,
      },
    },
  });

  const galleryThumbSlider = new Swiper(`.js-gallery-thumb-swiper`, {
    slidesPerView: `auto`,
    spaceBetween: 13,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      prevEl: `.arrow-button--prev`,
      nextEl: `.arrow-button--next`,
      disabledClass: `arrow-button--disabled`,
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
      },
      1199: {
        slidesPerView: 4,
      },
    },
  });

  const gallerySlider = new Swiper(`.js-gallery-swiper`, {
    slidesPerView: 1,
    spaceBetween: 20,
    thumbs: {
      swiper: galleryThumbSlider,
    },
  });

  const goodBoxSlider = new Swiper(`.js-good-box-swiper`, {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      prevEl: `.arrow-button--prev`,
      nextEl: `.arrow-button--next`,
      disabledClass: `arrow-button--disabled`,
    },
    breakpoints: {
      1199: {
        slidesPerView: 2,
      },
    },
  });

  const colorsSlider = new Swiper(`.js-colors-swiper`, {
    slidesPerView: 2,
    spaceBetween: 13,
    navigation: {
      prevEl: `.arrow-button--prev`,
      nextEl: `.arrow-button--next`,
      disabledClass: `arrow-button--disabled`,
    },
    breakpoints: {
      767: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1399: {
        slidesPerView: 5,
        spaceBetween: 40,
      },
    },
  });
};
